/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Miniapp_Login_Benefits1Inputs */

const vi_sitesettings_miniapp_login_benefits1 = /** @type {(inputs: Sitesettings_Miniapp_Login_Benefits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lợi ích đăng nhập`)
};

/**

* @param {Sitesettings_Miniapp_Login_Benefits1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_miniapp_login_benefits1 = /** @type {((inputs?: Sitesettings_Miniapp_Login_Benefits1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Miniapp_Login_Benefits1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_miniapp_login_benefits1(inputs)
});
export { sitesettings_miniapp_login_benefits1 as "siteSettings_miniapp_login_benefits" }